<template>
  <div class="travel-mode-page">
    <StandardResourceService
      title="定制游服务"
      :tab-list="tabList"
      v-model="activeTab"
    >
      <div v-show="activeTab === 'book'">
        <BookList v-if="tabLoaded.book"/>
      </div>
      <div v-show="activeTab === 'order'">
        <CustomOrderList v-if="tabLoaded.order"/>
      </div>
       <div v-show="activeTab === 'batchorder'">
        <BatchOrderList v-if="tabLoaded.batchorder"/>
      </div>
    </StandardResourceService>
  </div>
</template>

<script>
import StandardResourceService from '@/customComponents/standard/StandardResourceService.vue'
import BookList from '@/views/service/serviceProvider/customTravel/BookList.vue'
import CustomOrderList from '@/views/service/serviceProvider/customTravel/CustomOrderList.vue'
import BatchOrderList from '@/views/service_new/travel/Batchorder.vue'

export default {
  name: 'TravelMode',
  components: {
    StandardResourceService,
    BookList,
    CustomOrderList,
    BatchOrderList
  },
  data () {
    return {
      activeTab: 'book',
      tabList: [
        { label: '预约列表', key: 'book' },
        { label: '订单管理', key: 'order' },
        { label: '批量管理', key: 'batchorder' }
      ],
      // 已激活过的 tab（首次切换才挂载，挂载后保持存活，列表状态不丢失）
      tabLoaded: {
        book: true,
        order: false,
        batchorder: false
      }
    }
  },
  watch: {
    activeTab (val) {
      this.tabLoaded[val] = true
    }
  },
  activated () {
    // 从新建/详情页返回时，按 query.tab 回到来源 tab 并刷新列表
    const tab = this.$route.query.tab
    if (tab && this.tabList.some(item => item.key === tab)) {
      this.activeTab = tab
      this.tabLoaded[tab] = true
    }
  }
}
</script>

<style lang="less" scoped>
</style>
